import { Button } from './button.js';
import { Component } from './component.js';
import { PopupSurface } from './popup-surface.js';

export class DropdownButton extends Component {
  static defaultOptions = {
    componentName: 'DropdownButton',
    button: {},
    dropDown: {}
  };

  constructor (options) {
    super($.extend({}, DropdownButton.defaultOptions, options));
    this.button = new Button(this.options.button);
    this.add(this.button);

    this.button.el.on(
      'click',
      function () {
        this.toggle();
      }.bind(this)
    );

    this.dropDown = new PopupSurface(this.options.dropDown);
    this.add(this.dropDown);
  }

  open () {
    this.dropDown.show();
    this.onOpen();
  }

  close () {
    console.log('close called');
    this.dropDown.hide();
    this.onClose();
  }

  toggle () {
    console.log('toggle called');
    this.dropDown.toggle();
    if (this.dropDown.el.hasClass('open')) this.onOpen();
    else {
      if (this.options.triggerCloseEvent) {
        console.log('hopefully this calls');
        this.options.triggerCloseEvent.call();
      }
      this.onClose();
    }
  }

  onOpen () {
  }

  onClose () {
    if (this.options.triggerCloseEvent) {
      this.options.triggerCloseEvent.call();
    }
  }
}
